// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"city-ancient-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M16.0006 4.63921V10H15.9997L20.001 13H20.002V21H4.00195V13H4.00098L7.99966 10H8.00063V4.63901L11.9996 2L16.0006 4.63921Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M12 18V21M12.0023 5.99805H12.0063V6.00195H12.0023V5.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.00065 5.15V10M8.00065 10H16.0007M8.00065 10L4.00195 13M16.0007 5.15V10M16.0007 10L20.002 13M20.002 13H4.00195M20.002 13V21H4.00195V13M20.002 13H21.002M4.00195 13H3.00195M7.33398 5.07895L11.9996 2L16.6673 5.07895","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const CityAncient2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'city-ancient-2',
    ref,
    icon: element,
  },
));

CityAncient2Icon.displayName = 'CityAncient2Icon';

export default CityAncient2Icon;
